import React, { useContext } from 'react';
import {
  params, useDataModel, extend,
  number as numberType,
  shape as shapeType,
} from '@thd-nucleus/data-sources';
import {
  Card,
  CardBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { AddToContext } from '../../AddToContext';
import { TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const MODEL_NAME = 'copyListTileVertical';

/**
 * Tile component for copying from existing lists
 */
export const CopyListTileVertical = () => {
  const { setScreen } = useContext(AddToContext);
  const { data: listsData } = useDataModel('lists', {
    variables: {},
    context: { withAuth: true }
  });
  const isListsTileEnabled = listsData?.lists?.pagination?.totalResults > 1;

  const handleClick = () => {
    if (isListsTileEnabled) {
      // 10.1 AI Entry Points - Track copy from your lists entry point click
      triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
        entryPoint: 'copy from your lists'
      });
      setScreen('COPY_LIST_SUMMARY');
    }
  };

  return (
    <div onClick={handleClick} role="presentation" className="sui-h-full">
      <Card
        role="button"
        PaperProps={{ className: 'sui-h-full' }}
        aria-label="Copy materials from your existing lists"
        data-testid="copy-list-vertical"
      >
        <CardBody>
          <Typography variant="h6">
            Copy from your list
          </Typography>
          <div className="sui-mt-1">
            <Typography variant="body-small" color="subtle">
              {listsData && listsData.pagination?.totalResults > 0
                ? `Create a new list from ${listsData.pagination.totalResults} saved list${
                    listsData.pagination.totalResults > 1 ? 's' : ''
                  }`
                : 'Add items from your saved lists'}
            </Typography>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

CopyListTileVertical.displayName = 'CopyListTileVertical';

CopyListTileVertical.dataModel = extend({
  lists: params({ page: numberType(), pageSize: numberType() }).shape({
    pagination: shapeType({
      totalResults: numberType(),
    })
  })
});

export default CopyListTileVertical;
